
import { Shield, Eye, AlertTriangle } from "lucide-react";

interface ModeratedContentPlaceholderProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showIcon?: boolean;
  reason?: string;
}

const ModeratedContentPlaceholder = ({ 
  className = "", 
  size = 'md',
  showIcon = true,
  reason = "Content moderated for community guidelines"
}: ModeratedContentPlaceholderProps) => {
  const sizeClasses = {
    sm: 'w-12 h-12 text-xs',
    md: 'w-24 h-24 text-sm', 
    lg: 'w-32 h-32 text-base',
    xl: 'w-48 h-48 text-lg'
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  return (
    <div className={`${sizeClasses[size]} ${className} relative overflow-hidden rounded-lg bg-gradient-to-br from-gray-100 to-gray-200 flex flex-col items-center justify-center text-gray-500 border-2 border-dashed border-gray-300`}>
      <svg 
        viewBox="0 0 400 400" 
        className="absolute inset-0 w-full h-full opacity-20"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background pattern */}
        <defs>
          <pattern id="moderatedPattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <circle cx="20" cy="20" r="2" fill="#9CA3AF" opacity="0.3"/>
          </pattern>
        </defs>
        <rect width="400" height="400" fill="url(#moderatedPattern)" />
        
        {/* Silhouette */}
        <path 
          d="M200 80 C230 80 260 100 260 140 C260 145 260 150 258 155 L258 170 C258 175 258 180 255 185 L255 200 C255 205 252 210 248 215 L248 230 C248 235 245 240 240 245 L240 260 C240 265 235 270 230 275 L230 290 C230 295 225 300 215 302 L185 302 C175 300 170 295 170 290 L170 275 C165 270 160 265 160 260 L160 245 C155 240 152 235 152 230 L152 215 C148 210 145 205 145 200 L145 185 C142 180 142 175 142 170 L142 155 C140 150 140 145 140 140 C140 100 170 80 200 80 Z"
          fill="#9CA3AF"
          opacity="0.4"
        />
      </svg>
      
      <div className="relative z-10 flex flex-col items-center justify-center space-y-2">
        {showIcon && (
          <div className="flex items-center space-x-1">
            <Shield className={`${iconSizes[size]} text-gray-400`} />
            <Eye className={`${iconSizes[size]} text-gray-400`} style={{ transform: 'scale(-1, 1)' }} />
          </div>
        )}
        
        <div className="text-center px-2">
          <div className="font-medium text-gray-600">Content Moderated</div>
          {size !== 'sm' && (
            <div className="text-xs text-gray-500 mt-1 leading-tight">
              {reason}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModeratedContentPlaceholder;
